import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  menuItemId: 0,
  updateListClasses: false,
  loginPageState: false,
  logoutCheck: false,
  advertisement: null,
  closeAccordionState: -1,
};

const interfaceSlice = createSlice({
  name: 'interface',
  initialState,
  reducers: {
    setMenuItemId(state, action) {
      state.menuItemId = action.payload;
    },
    setUpdateListClasses(state, action) {
      state.updateListClasses = action.payload;
    },
    setLogoutCheck(state, action) {
      state.logoutCheck = action.payload;
    },
    setAdvertisement(state, action) {
      state.advertisement = action.payload;
    },
    closeAccordion: (state, action) => {
      state.closeAccordionState = action.payload;
    },
  },
});

export const {
  setMenuItemId,
  setUpdateListClasses,
  setLogoutCheck,
  setAdvertisement,
  closeAccordion,
} = interfaceSlice.actions;
export default interfaceSlice.reducer;
